import { atom } from 'jotai'

// misc
export const isLoggedIn = atom(false)
export const openSignUpModal = atom(false)
export const openLoginModal = atom(false)
export const openShareModal = atom(false)
export const userEmail = atom('')
export const userContents = atom({})

export const isSharedContent = atom(false)

export const todosFocusId = atom('')

export const cardsShowModal = atom(false)
export const cardsEditId = atom('')
export const cardsBlockEditId = atom('')

export const collectionData = atom({})

export const headerSize = atom(0)

// builder
export const isBuilder = atom(false)
export const screen = atom('')
export const screenOpen = atom(false)
export const blockEditID = atom('')
export const blockEditType = atom('')
export const staticFocusKey = atom('')
export const addBlockIndex = atom(null)

// manifest content
export const manifestStatic = atom({})
export const manifestDesign = atom({})
export const manifestBlocks = atom([])

// page content
export const pageContentStatic = atom({})
export const pageContentDesign = atom({})
export const pageContentBlocks = atom([])

export const premiumCustomCSS = atom('')
